;
define("footer.tpl", function(){});

